import commonPageService from 'mCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import video from 'globalCommon/utils/video';
import './style.css';

function init() {
    commonPageService({ renderAfter: syncRender });
    video.init();
}

init();
